import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from '@shared/services';
import { ContextTree } from '@system/context/context.model';

@Injectable({ providedIn: 'root' })
export class ContextService {
  constructor(private httpService: HttpService) {}

  getContextTree(): Observable<ContextTree> {
    return this.httpService.get<ContextTree>('_api/Contracts/GetContextTree', {
      useLoader: false,
    });
  }
}
